module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_counter.a92a9894.svg";